var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoRepos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 24C23.4919 24 17 30.4919 17 38.5V71.5C17 79.5081 23.4919 86 31.5 86H78.5C86.5081 86 93 79.5081 93 71.5V38.5C93 30.4919 86.5081 24 78.5 24H31.5ZM26 38.5C26 35.4624 28.4624 33 31.5 33H78.5C81.5376 33 84 35.4624 84 38.5V71.5C84 74.5376 81.5376 77 78.5 77H31.5C28.4624 77 26 74.5376 26 71.5V38.5ZM65.1984 48.6422C66.37 47.4706 66.37 45.5711 65.1984 44.3995C64.0268 43.228 62.1274 43.228 60.9558 44.3995L55.2989 50.0564L49.6421 44.3995C48.4705 43.228 46.571 43.228 45.3994 44.3995C44.2279 45.5711 44.2279 47.4706 45.3994 48.6422L51.0563 54.299L45.3994 59.9559C44.2279 61.1274 44.2279 63.0269 45.3994 64.1985C46.571 65.3701 48.4705 65.3701 49.6421 64.1985L55.2989 58.5417L60.9558 64.1985C62.1273 65.3701 64.0268 65.3701 65.1984 64.1985C66.37 63.0269 66.37 61.1274 65.1984 59.9559L59.5416 54.299L65.1984 48.6422Z",
    fill: "#808080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRepos);
export default __webpack_public_path__ + "static/media/no-repos.5291997fccc70a5aa2dfbaef61f8c6e2.svg";
export { ForwardRef as ReactComponent };